const init = () => {
  const els = [...document.querySelectorAll('[data-plugin="mobile-footer-action"]')];

  if (!els.length) return;

  let bookForm = document.querySelector('#book');
  let triggerPoint = window.innerHeight;
  let absoluteTop = 0;

  const calculateValues = () => {
    bookForm = document.querySelector('#book');
    if (bookForm) {
      absoluteTop = getAbsoluteTop(bookForm);
      triggerPoint = absoluteTop + bookForm.offsetHeight - window.innerHeight / 3;
      if (triggerPoint > 3000) {
        triggerPoint = window.innerHeight;
      }
    } else {
      triggerPoint = window.innerHeight;
    }
  };

  calculateValues();

  const handleScroll = () => {
    if (window.scrollY > triggerPoint) {
      els.forEach((el) => {
        const dataType = el.getAttribute('data-type');
        if (dataType === 'action') {
          el.classList.remove('-bottom-14');
          el.classList.add('bottom-1');
        } else if (dataType === 'button') {
          el.classList.remove('-bottom-16');
          el.classList.add('bottom-0');
        }
      });
      document.body.classList.add('Body--showFooterAction');
      if (!bookForm) {
        window.removeEventListener('scroll', handleScroll);
        window.removeEventListener('resize', calculateValues);
      }
    }

    // If the form is in view, hide the button
    if (bookForm) {
      const formBottom = absoluteTop + bookForm.offsetHeight - window.innerHeight / 3;
      const thirdInViewPoint = absoluteTop - window.innerHeight + window.innerHeight / 3;

      if (window.scrollY >= thirdInViewPoint && window.scrollY <= formBottom) {
        els.forEach((el) => {
          const dataType = el.getAttribute('data-type');
          if (dataType === 'action') {
            el.classList.add('-bottom-14');
            el.classList.remove('bottom-1');
          } else if (dataType === 'button') {
            el.classList.add('-bottom-16');
            el.classList.remove('bottom-0');
          }
        });
        document.body.classList.remove('Body--showFooterAction');
      }
    }
  };

  window.addEventListener('scroll', handleScroll);
  window.addEventListener('resize', calculateValues);
};

const getAbsoluteTop = (el) => {
  let top = 0;
  while (el) {
    top += el.offsetTop;
    el = el.offsetParent;
  }
  return top;
};

export default init;
